/****************************************************
 * Module Name:  TenderProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class TenderProxy {
    static GetAllTenders = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tender",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleTender = (tenderId, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/tender/${tenderId}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddTender = (tender, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tender",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(tender),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateTender = (tender, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tender",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(tender),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


}